import { render, staticRenderFns } from "./BusHome.vue?vue&type=template&id=cefccc96&scoped=true&"
import script from "./BusHome.vue?vue&type=script&lang=js&"
export * from "./BusHome.vue?vue&type=script&lang=js&"
import style0 from "./BusHome.vue?vue&type=style&index=0&id=cefccc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefccc96",
  null
  
)

export default component.exports